import { AssetType } from 'interfaces'
import { getAppFeatures } from '../getAppFeatures'

const assetsAllowed = getAppFeatures()?.features?.assetsAllowed

export const filterAssetsById = <T extends { id: AssetType | string }>(
  elem: T,
): boolean => assetsAllowed.includes(elem.id as AssetType)

export const filterByRelatedAsset = <T extends { relatedAsset?: AssetType }>(
  elem: T,
): boolean => !elem?.relatedAsset || assetsAllowed.includes(elem?.relatedAsset)
